import { SeverityLevel } from '@sentry/core';

import { ELogLevel } from '../../../shared/constants';
import { TLogLevel } from '../../../shared/types';

/**
 * Get string representation of log level
 */
export function logLevelToString(level: ELogLevel): string {
	switch (level) {
		case ELogLevel.DEBUG:
			return 'DEBUG';
		case ELogLevel.INFO:
			return 'INFO';
		case ELogLevel.WARN:
			return 'WARN';
		case ELogLevel.ERROR:
			return 'ERROR';
		default:
			return 'UNKNOWN';
	}
}

/**
 * Map internal log level to Sentry SeverityLevel
 */
export const mapELogLevelToSentryLevel = (level: ELogLevel): SeverityLevel => {
	switch (level) {
		case ELogLevel.DEBUG:
			return 'debug';
		case ELogLevel.INFO:
			return 'info';
		case ELogLevel.WARN:
			return 'warning';
		case ELogLevel.ERROR:
			return 'error';
		default:
			return 'info';
	}
};

/**
 * Map Sentry level string to internal log level enum
 * @param level - Sentry-compatible level string (optional)
 * @returns Internal log level enum
 */
export const mapSentryLevelToELogLevel = (level?: TLogLevel): ELogLevel => {
	switch (level) {
		case 'debug':
			return ELogLevel.DEBUG;
		case 'info':
			return ELogLevel.INFO;
		case 'warn':
			return ELogLevel.WARN;
		case 'error':
			return ELogLevel.ERROR;
		default:
			return ELogLevel.INFO;
	}
};
